import { ToastType } from "../components/common/Toast/types";

export const defaultErrorMessage: ToastType = {
  type: "error",
  message: "Something went wrong",
};
